
<div class="modal-dialog modal-lg">
  <div class="modal-content p-3">
    <div class="modal-header border-bottom-0">
      <h4 class="modal-title" style="color: red;">Error</h4>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body container-fluid">
      <div style="color: red;">
        <p>Below errors can occur because of incorrect data in ITSM or MS4.</p>
        <p>Please review this data in either or both systems.</p>
      </div>
      <div *ngFor="let item of _errorMessages">
        <error [error]="item"></error>
      </div>
    </div>
  </div>
</div>